var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPrettyDots = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 347.587,
  height: 301.143
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-1 -4596.154 60746.292)",
  opacity: 0.477
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 1",
  cx: 2.111,
  cy: 2.111,
  r: 2.111,
  transform: "translate(1227.391 254.181)",
  fill: "#ff66c4"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 5",
  cx: 3.895,
  cy: 3.895,
  r: 3.895,
  transform: "translate(1245.697 151.452)",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 14",
  cx: 3.895,
  cy: 3.895,
  r: 3.895,
  transform: "translate(1396.286 95.481)",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 81",
  cx: 3.895,
  cy: 3.895,
  r: 3.895,
  transform: "translate(1396.286 255.481)",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 9",
  cx: 3.895,
  cy: 3.895,
  r: 3.895,
  transform: "translate(1359.946 195.161)",
  fill: "#ff66c4"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 6",
  cx: 3.895,
  cy: 3.895,
  r: 3.895,
  transform: "translate(1152.653 303.785)",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 11",
  cx: 3.895,
  cy: 3.895,
  r: 3.895,
  transform: "translate(1111.108 95.193)",
  fill: "#6cbbed"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 12",
  cx: 3.895,
  cy: 3.895,
  r: 3.895,
  transform: "translate(1057.012 230.215)",
  fill: "#ff66c4"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 7",
  cx: 3.895,
  cy: 3.895,
  r: 3.895,
  transform: "translate(1139.67 138.037)",
  fill: "#9472c0"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 8",
  cx: 3.895,
  cy: 3.895,
  r: 3.895,
  transform: "translate(1243.533 364.804)",
  fill: "#ff66c4"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 13",
  cx: 3.895,
  cy: 3.895,
  r: 3.895,
  transform: "translate(1131.447 377.787)",
  fill: "#9472c0"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 80",
  cx: 3.895,
  cy: 3.895,
  r: 3.895,
  transform: "translate(1341.447 387.787)",
  fill: "#9472c0"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 10",
  cx: 3.895,
  cy: 3.895,
  r: 3.895,
  transform: "translate(1276.423 216.799)",
  fill: "#9472c0"
}))));
export default SvgPrettyDots;